<app-whatsapp-button></app-whatsapp-button>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
            <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
            <h2>Olá, {{ usuario.fullName }}, <a [routerLink]="['/login']">sair</a></h2>
            <p>Aqui você pode consultar atendimentos já realizados ou solicitar um novo atendimento.</p>
        </div>
    </div>
</div>
<footer id="main-cta" class="dash-cta">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="row justify-content-end">
                    <div class="col-lg-6">
                        <a class="btn btn-primary btn-block" [routerLink]="['/cadastro']">Editar dados</a>
                    </div>
                    <div class="col-lg-6">
                        <a class="btn btn-primary btn-block" [routerLink]="['/app/servico']">+ Novo Atendimento</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6" [ng2-loading]="showSpinner">

            <h2>Protocolos</h2>

            <div class="form-panel" *ngFor="let agendamento of agendamentos">
                <header class="row">
                    <div class="col-5">
                        <h3><span *ngIf="agendamento.appointment">Agendamento </span><span *ngIf="!agendamento.appointment">Solicitação</span> #{{ agendamento.protocol }}</h3>
                    </div>
                    <div class="col-4 text-right caption">
                        {{ agendamento.createdDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}
                    </div>
                    <div class="col-3">
                        <button class="btn btn-primary float-right" (click)="open(agendamento.protocol,modalInfo)" >+Info</button>
                    </div>
                </header>

                <!-- Modal de informações do protocolo -->
                <ng-template #modalInfo let-modal>
                    <div class="modal-header">
                        <h1 class="modal-title" id="modalInfoLabel">
                          Histórico de ações da solicitação
                        </h1>
                        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                            <span aria-hidden="true">×</span>
                          </button>
                      </div>
                      <div class="modal-body">
                        <ul>
                          <li *ngFor="let log of agendamento.logDataList">
                                <h2>{{ log.content }}</h2>
                                <p>{{ log.ts | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}<br>
                                    {{ log.text }}
                                </p>
                          </li>
                        </ul>
                        <div class="col-12" *ngIf="agendamento.logDataList.length < 1" style="padding:20px;text-align:center;"><h4>Sem ações para este protocolo</h4></div>
                      </div>
                </ng-template>

                <div class="caption mb-2" *ngIf="!agendamento.appointment">
                    <div>
                      <span>{{ agendamento.serviceName }}</span>
                    </div>
                    <div>
                      <span>{{ agendamento.serviceTypeVO?.description }}</span>
                    </div>
                    <div>
                      <span>Data da Solicitação: {{ agendamento.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                    </div>
                    <div class="text-success" *ngIf="agendamento.attendanceAnswer && agendamento.attendanceAnswer != '' && agendamentos.length && agendamento.statusType == 'CLOSED'">
                      <span>Resposta: <b>{{ agendamento.attendanceAnswer }}</b> </span>
                    </div>
                    <div class="card-status error" *ngIf="agendamento.attendanceAnswer && agendamento.attendanceAnswer != '' && agendamentos.length && (agendamento.statusType == 'CANCELED' || agendamento.statusType == 'INVALID_PHOTO' || agendamento.statusType == 'INVALID_DATA')">
                      <span>Resposta: <b>{{ agendamento.attendanceAnswer }}</b> </span>
                    </div>
                </div>

                <div class="caption mb-2" *ngIf="agendamento.appointment">
                    <div>
                        <span>{{ agendamento.serviceName }}</span>
                    </div>
                    <div>
                        <span>{{ agendamento.serviceTypeVO?.description }}</span>
                    </div>
                    <div>
                        <span>Local: {{ agendamento.serviceLocation }}</span>
                    </div>
                    <div>
                        <span>Endereço: {{ agendamento.locationAddress }}</span>
                    </div>
                    <div>
                      <span>Data de Agendamento: {{ agendamento.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                    </div>
                    <div class="text-success" *ngIf="agendamento.attendanceAnswer && agendamento.attendanceAnswer != '' && agendamentos.length && agendamento.statusType == 'CLOSED'">
                        <span>Resposta: <b>{{ agendamento.attendanceAnswer }}</b> </span>
                    </div>
                    <div class="card-status error" *ngIf="agendamento.attendanceAnswer && agendamento.attendanceAnswer != '' && agendamentos.length && (agendamento.statusType == 'CANCELED' || agendamento.statusType == 'INVALID_PHOTO' || agendamento.statusType == 'INVALID_DATA')">
                        <span>Resposta: <b>{{ agendamento.attendanceAnswer }}</b> </span>
                    </div>
                </div>

                <footer class="row align-items-center card-status error">
                    <div class="col-12 col-lg text-warning" *ngIf="agendamento.statusType == 'REGULAR'">
                        <img src="assets/icons/warning.svg" alt="Pendente" />
                        {{ agendamento.status }}
                        <button *ngIf="agendamento.canCancel" class="btn btn-primary float-right" (click)="cancelaAgendamento(agendamento.protocol)">Cancelar</button>
                    </div>
                    <div class="col-6 col-lg text-warning" *ngIf="agendamento.statusType == 'WAITING_THIRD_PARTY'">
                        <img src="assets/icons/warning.svg" alt="Pendente" />
                        {{ agendamento.status }}
                    </div>
                    <div class="col-6 col-lg" *ngIf="agendamento.statusType == 'CANCELED' || agendamento.statusType == 'THIRD_PARTY_CANCELED'">
                        <img src="assets/icons/error.svg" alt="Erro" />
                        {{ agendamento.status }}
                    </div>
                    <div class="col-6 col-lg text-success" *ngIf="agendamento.statusType == 'CLOSED' || agendamento.statusType == 'THIRD_PARTY_CLOSED'">
                        <img src="assets/icons/success.svg" alt="Finalizado" />
                        {{ agendamento.status }}
                    </div>
                    <div class="col-12" *ngIf="agendamento.statusType == 'INVALID_DATA'">
                        <img src="assets/icons/error.svg" alt="Erro" />
                        {{ agendamento.status }}
                        <button *ngIf="agendamento.pendingDataList.length > 0" class="btn btn-primary float-right" (click)="editAgendamento(agendamento)">Corrigir</button>
                        <!-- <a href="#"  class="btn btn-small btn-primary btn-block" [routerLink]="['/app/agendamento', agendamento.protocol]">Corrigir</a> -->
                    </div>
                    <div class="col-12" *ngIf="agendamento.statusType == 'INVALID_PHOTO'">
                        <img src="assets/icons/error.svg" alt="Erro" />
                        {{ agendamento.status }}
                        <button *ngIf="agendamento.pendingDataList.length > 0" class="btn btn-primary float-right" (click)="editAgendamento(agendamento)">Corrigir</button>
                        <!-- <a href="#"  class="btn btn-small btn-primary btn-block" [routerLink]="['/app/agendamento', agendamento.protocol]">Corrigir</a> -->
                    </div>

                    <div class="col-12 text-warning" *ngIf="agendamento.needPayment && agendamento.serviceNeedPayment">
                      <img src="assets/icons/warning.svg" alt="Pendente" />
                      {{ "Pagamento Pendente" }}
                      <button class="btn btn-primary float-right" (click)="pagarAgendamento(agendamento)">Pagar</button>
                    </div>

                    <div class="col-12" *ngIf="agendamento.statusType == 'CANCELED' && agendamento.serviceNeedPayment">
                      <img src="assets/icons/error.svg" alt="Cancelado" />
                      {{ "Pagamento Cancelado" }}
                    </div>

                    <div class="col-12 text-success" *ngIf="!agendamento.needPayment && agendamento.serviceNeedPayment && (agendamento.statusType == 'REGULAR' || agendamento.statusType == 'CLOSED' || agendamento.statusType == 'WAITING_THIRD_PARTY' || agendamento.statusType == 'INVALID_DATA' || agendamento.statusType == 'INVALID_PHOTO')">
                      <img src="assets/icons/success.svg" alt="Pagamento realizado" />
                      {{ "Pagamento Realizado" }}
                    </div>
                </footer>
            </div>

            <div class="row justify-content-center" *ngIf="hasMoreProtocols">
              <a class="btn btn-primary btn-block ml-5 mr-5" (click)="getMoreProtocols()">Protocolos anteriores</a>
            </div>

            <div class="form-panel" *ngIf="agendamentos && agendamentos.length == 0">
                Nenhum agendamento ou solicitação realizado.
            </div>
        </div>
    </div>
</div>
